import SettingsIcon from '@mui/icons-material/Settings';
import { Button, CircularProgress, Grid, IconButton, Typography } from '@mui/material';
import type { RefObject } from 'react';

// Types for ViewPageHeader
interface ViewPageHeaderProps {
  dataLength: number;
  exporting: boolean;
  handleExport: () => void;
  exportError: string | null;
  dialogRef: RefObject<{ openDialog: (visibleEmissions: any[], visibleDimensions: any[]) => void }>;
  visibleEmissions: any[];
  visibleDimensions: any[];
}

export const ViewPageHeader = ({
  dataLength,
  exporting,
  handleExport,
  exportError,
  dialogRef,
  visibleEmissions,
  visibleDimensions,
}: ViewPageHeaderProps) => (
  <Grid container item alignItems="center" spacing={3}>
    <Grid item xs={2}>
      <Typography variant="h4">Granska</Typography>
    </Grid>
    <Grid item xs={2}>
      <Button variant="contained" color="primary" disabled={dataLength <= 0 || exporting} onClick={handleExport}>
        Exportera
      </Button>
      {exporting && <CircularProgress size={24} />}
    </Grid>
    <Grid item xs={7}>
      <Typography color="error">{exportError}</Typography>
    </Grid>
    <Grid item xs={1} style={{ textAlign: 'right' }}>
      <IconButton
        onClick={() => (dialogRef.current ? dialogRef.current.openDialog(visibleEmissions, visibleDimensions) : {})}
        size="large"
      >
        <SettingsIcon />
      </IconButton>
    </Grid>
  </Grid>
);
